require('./adapters/polyfill.js')

const hotjar = require('./adapters/hotjar.js')
const clarity = require('./adapters/clarity.js')
const googleAnalytics = require('./adapters/googleAnalytics.js')
const segment = require('./adapters/segment.js')
const { analyticTools } = require('./common/constants')
const standardTracking = require('./common/standardTracking')
const standardSchemas = require('./common/standardSchemas')
const eventTracking = require('./common/eventTracking')
const abTesting = require('./common/abTesting')

/* Remember current analytics enabled settings */
const analyticsEnabled = new Set()

/* Exported Functions */

function init(config) {
  if (!config) {
    return Promise.resolve({ msg: 'config missing' })
  }

  if (config.analytics) {
    const { adc: analyticsConfig } = config.analytics
    const toolsLoaded = []
    const message = '%c Loading '
    if (analyticsConfig[analyticTools.hotjar].enabled) {
      hotjar.setUpHotjarScripts(analyticsConfig[analyticTools.hotjar].id)
      toolsLoaded.push('HotJar')
      analyticsEnabled.add(analyticTools.hotjar)
    }

    if (analyticsConfig[analyticTools.clarity].enabled) {
      clarity.setUpClarityScripts(analyticsConfig[analyticTools.clarity].id)
      toolsLoaded.push('Clarity')
      analyticsEnabled.add(analyticTools.clarity)
    }

    if (analyticsConfig[analyticTools.ga].enabled) {
      googleAnalytics.setUpGoogleAnalyticsScripts(
        analyticsConfig[analyticTools.ga].id
      )
      toolsLoaded.push('Google Analytics')
      analyticsEnabled.add(analyticTools.ga)
    }

    if (analyticsConfig[analyticTools.gtm].enabled) {
      googleAnalytics.setUpGoogleTagManagerScripts(
        new Date().getTime(),
        analyticsConfig[analyticTools.gtm].gtm_id_mkt
      )
      toolsLoaded.push('Google Tag Manager')
      analyticsEnabled.add(analyticTools.gtm)
    }

    // eslint-disable-next-line no-console
    console.info(
      `${message}${toolsLoaded.join(', ')}`,
      'background: #036eb5; color: #fff; padding: 3px 6px;'
    )

    return Promise.resolve({})
  } else {
    return Promise.resolve({ msg: 'Invalid analytics config passed' })
  }
}

// Page Load Tracking
function firePageTrackingWithContext(
  gaPath = window.location.pathname,
  shouldFireGATracking = true
) {
  if (analyticsEnabled.has(analyticTools.ga) && shouldFireGATracking) {
    googleAnalytics.firePageTracking(gaPath)
  }
}

module.exports = {
  init,
  firePageTrackingWithContext,
  segment,
  standardTracking,
  standardSchemas,
  abTesting,
  ...eventTracking,
}
